import gql from 'graphql-tag'
import * as React from 'react'
import Raven from 'raven-js'
import { Mutation } from 'react-apollo'
import { Redirect } from 'react-router'
import { login, logout } from 'web-fns/dist/auth'
import Button from 'web-makeup/dist/Button'
import Notification from 'web-makeup/dist/Notification'
import SectionContainer from 'web-makeup/dist/SectionContainer'
import loadJS from 'scriptjs'
import styled from 'styled-components'
import { generateErrors, handleSideEffectErrors } from 'web-fns/dist/error'

import { LoginManagerMutation } from '../../typings/types'

const StyledButton = styled(Button as any)`
  position: relative;
  padding: 0 2.125rem 0 4.125rem;
`

const StyledImg = styled.img`
  position: absolute;
  left: 0;
  top: 0;
`
type State = { screen: 'INITIALIZING' } | { screen: 'INITIALIZED' }

interface OwnProps {
  loadJS?: (key: string, cb: () => void) => void
  clientId: string
}

type Props = OwnProps

export const LOGIN = gql`
  mutation LoginManagerMutation($idToken: String!) {
    loginManagerWithGoogleAuth(idToken: $idToken) {
      jwt
    }
  }
`

export class GoogleLogin extends React.Component<Props, State> {
  static defaultProps: Partial<Props> = {
    loadJS,
  }

  constructor(props: Props) {
    super(props)
    this.state = { screen: 'INITIALIZING' }
    this.handleLogin = this.handleLogin.bind(this)
    this.initialize = this.initialize.bind(this)
  }

  async componentDidMount() {
    await this.initialize()
    await gapi.load('auth2', () => null)
  }

  initialize(): Promise<State> {
    const CLIENT_URL = 'https://apis.google.com/js/client:platform.js'

    const { loadJS: load } = this.props

    return new Promise(resolve => {
      if (!load) {
        return
      }
      load(CLIENT_URL, () => {
        this.setState({ screen: 'INITIALIZED' })
        resolve({ screen: 'INITIALIZED' })
      })
    })
  }

  handleLogin(callback) {
    const SCOPE =
      'https://www.googleapis.com/auth/admin.directory.group.readonly profile email openid'
    gapi.auth2.authorize(
      {
        client_id: this.props.clientId,
        scope: SCOPE,
        response_type: 'id_token permission',
      },
      async result => {
        if (!result.error) {
          try {
            await callback({ variables: { idToken: result.id_token } })
          } catch (error) {
            Raven.captureException(error)
            handleSideEffectErrors(generateErrors(error.graphQLErrors), [
              {
                'google.domain': e => {
                  if (e.codes.includes('INVALID')) {
                    Notification.error({
                      message: 'Unable to login',
                      description: 'Please login with 90seconds.com account',
                    })
                    logout()
                    return true
                  }
                  return false
                },
              },
            ])
          }
        }
      }
    )
  }

  render() {
    return (
      <SectionContainer>
        <Mutation mutation={LOGIN}>
          {(loginAsManager, { loading, data }) => {
            const result = (data &&
              data.loginManagerWithGoogleAuth) as LoginManagerMutation.LoginManagerWithGoogleAuth
            if (result && result.jwt) {
              login(data.loginManagerWithGoogleAuth.jwt)
              return <Redirect to="/requests" />
            }
            return (
              <>
                <StyledButton
                  data-qa="qa-button-login"
                  onClick={e => {
                    e.preventDefault()
                    this.handleLogin(loginAsManager)
                  }}
                  size="large"
                  type="primary"
                  loading={loading}
                  disabled={this.state.screen === 'INITIALIZING'}
                >
                  <StyledImg
                    src={`${
                      window.env.CLOUDINARY_DOWNLOAD_URL
                    }/upload/w_38,h_38/v1527836486/icons/google-logo.png`}
                  />
                  Sign In with @90seconds.com
                </StyledButton>
              </>
            )
          }}
        </Mutation>
      </SectionContainer>
    )
  }
}

export default GoogleLogin



// WEBPACK FOOTER //
// ./src/components/GoogleLogin/GoogleLogin.tsx